// extracted by mini-css-extract-plugin
export default {"userBadge":"UserBadge_userBadge__ZhOtw","withIcon":"UserBadge_withIcon__z2tHY","blue":"UserBadge_blue__Hrhyp","green":"UserBadge_green__fxgK2","black":"UserBadge_black__xRiXX"};